export const environment = {
  production: false,
  cognito: {
    userPoolId: 'eu-central-1_QEj9XV7Cd',
    clientId: '6t1lfr31rodqqqr0e12vg5n5ol',
    region: 'eu-central-1',
    domain: 'login.ocr-dev.admin.fidectus.com',
    redirectUri: 'https://ocr-dev.admin.fidectus.com/callback',
    logoutUri: 'https://ocr-dev.admin.fidectus.com/login'
  },
  apiUrl: 'https://api.ocr-dev.admin.fidectus.com',
  appsync: {
    httpEndpoint: 'https://gql.ocr-dev.admin.fidectus.com/graphql',
    realtimeEndpoint: 'wss://gql.ocr-dev.admin.fidectus.com/graphql/realtime'
  },
  // Engineer-facing dashboard created in lib/infrastructure/metrics.ts.
  cloudWatch: {
    region: 'eu-central-1',
    dashboardName: 'ocr-prime-monitoring-dev'
  }
};
